import { Outlet } from 'react-router-dom';
import { styles } from './AuthLayout.styles';

/**
 * Authentication Layout — light background, full viewport
 */
export const AuthLayout = () => (
  <div style={styles.layoutWrapper}>
    <Outlet />
  </div>
);
